import {createApi} from '@reduxjs/toolkit/dist/query/react';

import {TLookupValue} from 'modules/data/data-types';
import {IAttachment} from 'shared/types/files';
import {ERequestType} from 'shared/types/requests';
import {axiosBaseQuery} from 'store/api/base-query';

export interface IExplanationInformationAudit {
    id: string;
    statusCode: number;
    statusText: string;
    stage: TLookupValue;
    ticketId: string;
    mainDocument: IAttachment;
    createdDate: string;
    lastModifiedDate: string;
}

export type TExplanationInformationEntity = {
    id: string;
    mainDocNumber?: string;
    downloadDate?: string;
    mainDocument?: IAttachment;
    docTypeName?: string;
    downloadingAudit?: IExplanationInformationAudit;
    processingAudit?: IExplanationInformationAudit;
    responseRequirementAudit?: IExplanationInformationAudit;
    incomingProcessingAudit?: IExplanationInformationAudit;
    audits?: IExplanationInformationAudit[];
    protocolMainDocument?: IAttachment;
    responseRequirementDocument?: IAttachment;
    protocolResponseRequirementDocument?: IAttachment;
    protocolDocument?: IAttachment;
    responseDocument?: IAttachment;
};

export interface IGetExplanationInformationByDocIdArgs {
    id: string;
}

export interface IRunSubmitInabilityInfoServiceByDocIdArgs {
    id: string;
}

export const ExplanationInformationApi = createApi({
    reducerPath: 'explanationInformationApi',
    baseQuery: axiosBaseQuery(),
    tagTypes: ['ExplanationInformation'],
    endpoints: builder => ({
        getExplanationInformation: builder.query<TExplanationInformationEntity, IGetExplanationInformationByDocIdArgs>({
            query: ({id}) => ({
                url: `integration.module/explanation.information/${id}`,
            }),
            providesTags: ['ExplanationInformation'],
        }),
        runSubmitToDocRequestService: builder.mutation<void,
        {
          externalServiceName: 'submitExplanationProtocol' | 'submitExplanationResponse';
          mainDocNumber?: string;
        }
        >({
            query: ({externalServiceName, mainDocNumber}) => {
                const formData = new FormData();

                if (mainDocNumber) formData.append('mainDocNumber', mainDocNumber);
                formData.append('externalServiceName', externalServiceName);
                formData.append('externalServiceVersion', 'v3');

                return {
                    url: '/integration.module/monitor.services/execute',
                    data: formData,
                    method: ERequestType.POST,
                    formData: true,
                };
            },
        }),
    }),
});

export const {
    useGetExplanationInformationQuery,
    useLazyGetExplanationInformationQuery,
    useRunSubmitToDocRequestServiceMutation,
} = ExplanationInformationApi;
